export const listSurveys = (client, userId) => client.rpc('service-survey', '1/2019-05-31/list_surveys', { userId });
export const submitSurvey = (client, payload) => client.rpc('service-survey', '1/2019-05-31/submit_survey', payload);
